<template>
  <div class="page-product-specifications-accordions">
    <!-- Product Sizes  -->
    <WidgetAccordion v-if="sizes">
      <template #header
        ><h3 class="text-m">
          {{ $t('pages.product.specProductSizes') }}
        </h3></template
      >
      <template #content
        ><div class="text-s m-top-8px" v-html="sizes"></div>
      </template>
    </WidgetAccordion>

    <!-- Ceiling  -->
    <WidgetAccordion v-if="ceilingSize">
      <template #header
        ><h3 class="text-m">
          {{ $t('pages.product.specProductCeilingSize') }}
        </h3></template
      >
      <template #content
        ><div class="text-s m-top-8px" v-html="ceilingSize"></div>
      </template>
    </WidgetAccordion>

    <!-- Light source -->
    <WidgetAccordion v-if="lightSource">
      <template #header
        ><h3 class="text-m">
          {{ $t('pages.product.specProductLightSource') }}
        </h3></template
      >
      <template #content
        ><div class="text-s m-top-8px" v-html="lightSource"></div>
        <div class="text-s m-top-8px" v-if="props.meta.dimerable.length">
          ({{ $t('pages.product.specProductDimerable') }}
          {{ props.meta.dimerable.join(', ') }})
        </div>
      </template>
    </WidgetAccordion>

    <!-- Meta -->
    <WidgetAccordion
      v-for="accordion in props.product.productDetailsMeta"
      :key="accordion.id"
    >
      <template #header
        ><h3 class="text-m">
          {{ accordion.productDetailsMetaTitle }}
        </h3></template
      >
      <template #content
        ><div
          class="text-s m-top-8px"
          v-html="accordion.productDetailsMetaContent"
        ></div>
      </template>
    </WidgetAccordion>
  </div>
</template>

<script>
export default {
  name: 'PagesProductSpecificationsAccordions',
}
</script>

<script setup>
const props = defineProps({
  product: Object,
  meta: Object,
})

const { locale } = useI18n()

const sizes = computed(() => {
  return locale.value === 'en-us'
    ? props.product.productSizesUsa
    : props.product.productSizes
})

const ceilingSize = computed(() => {
  return locale.value === 'en-us'
    ? props.product.productCeilingSizeUsa
    : props.product.productCeilingSize
})

const lightSource = computed(() => {
  return locale.value === 'en-us'
    ? props.product.productLightSourceUsa
    : props.product.productLightSource
})
</script>

<style lang="scss">
@import './style.scss';
</style>
